import { Injectable } from '@angular/core';

@Injectable()
export class FileSizeUtils {

    constructor() { }

    /**
     * get converted file size
     */
    convertByteToMegaByte( byte: number ) {
        if ( byte == null ) {
            return 0;
        } else {
            if ( isNaN( byte ) === false ) {
                return byte / 1000000;
            } else {
                return byte;
            }
        }
    }
}
